<template src="./ImpersonationModal.html">
</template>

<script>
import axios from 'axios';
import loading from '@/components/PageLoader';

axios.defaults.headers.common['Pragma'] = 'no-cache';

export default {
  name: "impersonation-modal",
  components: {
    loading
  },
  props: {
    error: {
      type: Error | Object | null | undefined,
    },
    parentCallback: {
      type: Function
    }
  },
  data() {
    return {
      firstName: "",
      lastName: "",
      email: "",
      impersonateEpic: true,
      impersonateBP: false,
      isLoading: false,
      isSubmitting: false,
      submitError: null,
      sessionExpired: false
    }
  },
  computed: {
    titleMessage() {
      return "User Impersonation";
    },

    detailMessage() {
      return "Please enter the user you would like to impersonate";
    },
    shouldReload() {
      return this.error && this.error.config.method === 'get' || this.sessionExpired;
    },
    formValid(){
      return (this.impersonateBP || this.impersonateEpic) && this.firstName && this.lastName && this.email && this.$_veeObserver.refs.email.errors.length === 0;
    }
  },
  methods:
  {
    show() {
      this.$bvModal.show('impersonation-modal');
    },
    isImpersonated() {
      if (!this.$auth.isAuthenticated()) return;

      axios
        .get(`/users/impersonated`)
        .then(response =>
        {
          const { data, status } = response;
          this.$emit('is-impersonated', data);

          return data;
        })
        .catch(error => console.log(`An error occurred confirming if already impersonated: ${error}`));
    },
    handleOk(modalEvent) {
      modalEvent.preventDefault();
      if (this.formValid)
        this.impersonate();
    },
    handleSubmit() {
      //not sure this one is actually firing.
      if (this.formValid)
        this.impersonate();
    },
    impersonate() {
      const impersonateEndpoint = `/users/impersonated`;

      let app = this;

      this.isLoading = true;
      this.isSubmitting = true;

      axios.post(impersonateEndpoint, { firstName: this.firstName, lastName: this.lastName, email: this.email, impersonateInEchos: this.impersonateEpic, impersonateInBix: this.impersonateBP })
        .then(response => {

          app.isLoading = false;
          this.isSubmitting = false;

          if (response.status === 200)
          {
            this.$emit('impersonation-success', this.firstName, this.lastName, this.email, this.impersonateEpic, this.impersonateBP);

            this.firstName = "";
            this.lastName = "";
            this.email = "";
            this.submitError = null;

            this.$nextTick(() =>
            {
              this.$refs['impersonation-modal'].hide();
              if (this.shouldReload)
              {
                this.sessionExpired = false;
                this.$router.go();
              };
            })

          }
          // TODO better error handling
        })
        .catch(error =>
        {
          app.isLoading = false;
          this.isSubmitting = false;
          this.submitError = error;
          console.log(`An error occurred impersonating: ${error}`)
        })
    },
    unimpersonate() {
      const impersonateEndpoint = `/users/impersonated`;

      let app = this;

      this.isLoading = true;
      this.isSubmitting = true;

      axios.delete(impersonateEndpoint)
        .then(response => {

          app.isLoading = false;
          this.isSubmitting = false;

          if (response.status === 200) {
            this.$emit('impersonation-removed');

            this.firstName = "";
            this.lastName = "";
            this.email = "";
            this.submitError = null;

            this.$nextTick(() => {
              this.$refs['impersonation-modal'].hide();
              if (this.shouldReload) {
                this.sessionExpired = false;
                this.$router.go();
              };
            })

          }
          // TODO better error handling
        })
        .catch(error => {
          app.isLoading = false;
          this.isSubmitting = false;
          this.submitError = error;
          console.log(`An error occurred removing impersonation: ${error}`)
        })
    }
  },
  mounted() { },
}
</script>
